import axios from "axios";
export const useAccountsApi = accountHost => {
  const createUser = request => axios.post(`${accountHost}/email/login`, {
    ...request,
    create: 1,
    flow: 1,
    newsletterSubscribe: 1
  }, {
    headers: {
      "Content-Type": "application/json"
    },
    withCredentials: true
  });
  return {
    createUser
  };
};